import { from } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BROADCAST_ACCEPT_KNOCK, BROADCAST_UPDATE_KNOCK } from 'actions/Types';
import { CHAT_FULL_ACCESS } from 'constants/Permissions';
import { PRESENTER_BANNER } from 'constants/Banners';
import { KNOCK_ANSWER } from 'store/eventConstants';
import { withTimeout } from 'utils/utils';
import {
  getStreamingStatus,
  getRecordingStatus
} from '@shoflo/studio-redux/utils/streamHelper';
import clearKnock from '@shoflo/studio-redux/actions/knock/clearKnock';

import { ACCEPTED, PRESENTER } from 'constants/KnockTypes';

/**
 * Emits an event to the accepted Presenter socket
 *
 * @param socket
 */
export const acceptedKnock = socket => store => next => async action => {
  const { dispatch, getState } = store;

  const targetdActions = [
    `${BROADCAST_ACCEPT_KNOCK}`,
    `${BROADCAST_UPDATE_KNOCK}_SUCCESS`
  ];

  from([action])
    .pipe(filter($action => targetdActions.includes($action.type)))
    .subscribe(async $action => {
      if (
        $action.payload.type === PRESENTER &&
        $action.payload.status === ACCEPTED
      ) {
        let {
          attendeeRoster,
          program,
          team,
          broadcastSettings,
          banners,
          broadcastRecordings: { liveRecordings },
          broadcastStreamEndpoints: streamEndpoints
        } = getState();

        const hasChatAccess = team
          ? team.permissions.some(({ name }) => name === CHAT_FULL_ACCESS)
          : false;

        const presenterBanner = banners.find(
          banner => banner.source.value.templateType === PRESENTER_BANNER
        );

        const isRecording = getRecordingStatus(liveRecordings);
        const isStreaming = getStreamingStatus(streamEndpoints);

        const streamRecordStatus = {
          isRecording,
          isStreaming
        };

        const knockPayload = {
          broadcastId: $action.payload.broadcastId,
          socketId: $action.payload.socketId,
          knockId: $action.payload?._id,
          attendeeRoster,
          program,
          hasChatAccess,
          muteMeetingAudio: broadcastSettings.muteMeetingAudio || false,
          presenterBanner: presenterBanner || null,
          broadcastSettings,
          streamRecordStatus,
          sourceId: $action.payload.sourceId
        };

        socket.emit(
          KNOCK_ANSWER,
          knockPayload,
          withTimeout(
            () => {},
            () => {
              socket.emit(KNOCK_ANSWER, knockPayload);
            },
            3000
          )
        );
        dispatch(clearKnock($action.payload));
      }
    });
  return next(action);
};

export default acceptedKnock;
